export const formatCurrency = (value, currencySymbol) => {
  if (value == null || value === "-" || (typeof value === "number" && isNaN(value))) {
    return "-";
  }
  if (typeof value === "number") {
    return `${currencySymbol || ""}${value.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  }
  return String(value);
};

export const formatPercentage = (value) => {
  if (value == null || value === "-" || (typeof value === "number" && isNaN(value))) {
    return "-";
  }
  if (typeof value === "number") {
    return `${Math.round(value)}%`;
  }
  return String(value);
};

export const formatCellValue = (value, type, currencySymbol) => {
  if (value == null || value === "-") {
    return "-";
  }

  switch (type) {
    case "currency":
      return formatCurrency(value, currencySymbol);
    case "percentage":
      return formatPercentage(value);
    case "number":
      return typeof value === "number" ? value.toLocaleString() : String(value);
    default:
      return String(value);
  }
};

